/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(8),
  flexWrap: 'wrap',
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.semantic_dark?.surface.surface1,
  marginBottom: theme.spacing(4),
}));

export const FieldGroup = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const FieldLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const FieldValue = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
}));
